<template>
  <div id="crew-controls-sidebar">

    <vs-prompt
      ref="crewControlsSidebar"
      :active.sync="sidebarStatus"
      class="crew-prompt"
      buttons-hidden
      :title="dialogTitle || ''"
      :color="AISEA_COLOR.BLACK"
    >
      <div v-if="closeButton" style="position: absolute; top: 10px; right: 10px;">
        <feather-icon icon="XIcon" svg-classes="h-6 w-6" @click="sidebarStatus = false" />
      </div>
      <div class="w-full crew-controls-sidebar-area" style="max-height: calc(100vh - 160px); overflow-y: auto;" >
        <slot name="crewControlSidebarBody" />
      </div>
    </vs-prompt>

  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  props: {
    activeSidebarCrew: Boolean,
    sidebarWidth: String,
    dialogTitle: String,
    closeButton: Boolean,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
    };
  },
  watch: {
    sidebarStatus(val) {
      if (val === true && this.$refs.crewControlsSidebar) {
        this.$nextTick(() => {
          let sidebarEl = this.$refs.crewControlsSidebar.$el.querySelector('.vs-dialog');
          sidebarEl.style['max-width'] = this.sidebarWidth || '560px';

          if ( this.closeButton !== false) {
            let closeButton = this.$refs.crewControlsSidebar.$el.querySelector('.vs-dialog-cancel');
            closeButton.style['display'] = 'none';
          }

        });
      }
    }
  },
  computed: {
    sidebarStatus: {
      get()    { return this.activeSidebarCrew; },
      set(val) { this.$emit('update:activeSidebarCrew', val) }
    },
  },
  methods: {}
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#crew-controls-sidebar {
  .crew-controls-sidebar-area { 
    background-color: #FFFFFF; 
    border-radius: 12px 0 0 12px;
    padding: 4px;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.crew-prompt {
  .vs-dialog {
    min-height: calc(100vh - 40px - 40px) !important;

    .dialog-title {
      font-family: $aisea-font-family !important;
      font-size: 18px;
    }

    .vs-dialog-cancel {
      background-color: rgba(244, 244, 244, 0.0) !important;
      transform: none !important;
      box-shadow: none !important;
    }

  }
}

</style>
